import { useCallback, useEffect, useRef, useState } from "react";
import { EventEmitter } from "nate-react-api-helpers";
const heartbeat = new EventEmitter();
setInterval(() => { heartbeat.emit(true); }, 60 * 1000);
function decodeItem(key, defaultValue) { const value = localStorage.getItem(key); if (value === null) {
    return defaultValue;
} const valueObj = JSON.parse(value); if (!valueObj) {
    localStorage.removeItem(key);
    return defaultValue;
} if (valueObj.expiresAt <= Date.now())
    return defaultValue; return valueObj.value; }
export function useLocalStorage(key, defaultValue) { const [value, setValue] = useState(decodeItem(key, defaultValue)); const defaultValueRef = useRef(defaultValue); defaultValueRef.current = defaultValue; useEffect(() => { setValue(decodeItem(key, defaultValueRef.current)); }, [key]); useEffect(() => { const sub = heartbeat.subscribe(() => { setValue(decodeItem(key, defaultValueRef.current)); }); return () => sub.cancel(); }, [key]); const onChangeCb = input => { if (input === null) {
    localStorage.removeItem(key);
    setValue(defaultValueRef.current);
    return;
} localStorage.setItem(key, JSON.stringify(input)); setValue(input.value); }; const onChangeRef = useRef(onChangeCb); onChangeRef.current = onChangeCb; const onChange = useCallback(value => onChangeRef.current(value), []); return [value, onChange]; }
